/* eslint-disable no-throw-literal */
import apiClient from './apiClient.js';

export const getAppUsers = () => apiClient.get('/app-users');
export const getAppUserById = (id) => apiClient.get(`/app-users/${id}`);
export const getAppUsersAll = () => apiClient.get('/app-users/all');
export const getAppUserAllById = (id) => apiClient.get(`/app-users/${id}`);
export const updateAppUser = (id, data) => apiClient.put(`/app-users/${id}`, data);
export const deleteAppUser = (id) => apiClient.delete(`/app-users/${id}`);
export const deleteAppUserAll = (id) => apiClient.delete(`/app-users/all/${id}`);
export const getAppUserByEmail = (email) => apiClient.get(`/app-users/email/${email}`);

export const createAppUser = async (data) => {
  try {
    const response = await apiClient.post('/app-users', data);
    return response.data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 409) {
          throw { type: 'duplicate', message: error.response.data?.error || 'El usuario ya existe.' };
      }
      throw { type: 'general', message: error.response.data?.error || 'Ha ocurrido un error, por favor intente nuevamente.' };
    }
    throw { type: 'general', message: 'Error de conexión, por favor intente nuevamente.' };
  }
};
